import type { Acces, Niveau, Utilisateur } from './types';

/**
 * Les droits selon le niveau (db/030-niveaux-bureau.sql). La base décide ; ces
 * fonctions ne servent qu'à ne pas montrer un bouton qui serait refusé.
 */

/** Un assistant n'ouvre que la saisie des entreprises et des partenaires. */
export function accesDe(u: Pick<Utilisateur, 'role' | 'niveau'>): Acces {
  return u.role === 'bureau' && u.niveau === 'assistant' ? 'assistant' : u.role;
}

export const estCeo = (u: Pick<Utilisateur, 'niveau'>): boolean => u.niveau === 'ceo';

/** Passer une entreprise en « non réalisable » depuis sa fiche : le CEO et les administrateurs (db/048). */
export const peutDeclarerNonRealisable = (u: Pick<Utilisateur, 'role' | 'niveau'>): boolean =>
  u.role === 'bureau' && (u.niveau ?? 'ceo') !== 'assistant';

/**
 * Ce que seul le CEO ouvre (« À traiter »). Un compte du bureau sans niveau
 * n'existe qu'en démo et dans les essais : il voit tout.
 */
export const voitCommeCeo = (u: Pick<Utilisateur, 'role' | 'niveau'>): boolean =>
  u.role === 'bureau' && (u.niveau ?? 'ceo') === 'ceo';

export const LIBELLE_NIVEAU: Record<Niveau, string> = {
  ceo: 'CEO',
  administrateur: 'Administrateur',
  assistant: 'Assistant',
};

/** Ce que chaque niveau peut faire, dit en une ligne. */
export const AIDE_NIVEAU: Record<Niveau, string> = {
  ceo: 'La plus haute autorité : personne d’autre ne peut le suspendre ni changer son niveau.',
  administrateur: 'Tous les droits du bureau : chantiers, validations, planning, administration.',
  assistant: 'La saisie des entreprises et des partenaires, rien d’autre.',
};
